import React from 'react';
import { BusinessCardArtwork } from './business-card/BusinessCardArtwork';
/**
 * Dentico Business Card — English Master (Dentico_Business_Card_EN)
 * The approved master. UA + RU documents are duplicates of this artwork with
 * only the front-side subtitle translated.
 */
export function BusinessCardNewPage() {
  return <BusinessCardArtwork docName="Dentico Business Card — English Master" subtitle={['Private Dental Clinic in London']} data-id="element-1182" />;
}